/**
 * 官网地址，目前都给线上地址即可
 */
const officeSite = 'https://identity.tencent.com';
const officeSiteIntl = 'https://identity.tencentid.com';

/**
 * 私有化环境变量
 */
export const getPrivateEnv = () => {
  const { protocol, host, pathname } = window.location;
  const curPathname = pathname.replace(/^(\/eid\/.*)/, '');
  const curPath = _.trimEnd(`${protocol}//${host}/${curPathname}`, '/');

  window.ONEID_PUBLIC_CDN_URL = `${curPath}/eid/public/`;
  window.ONEID_PUBLIC_GATEWAY_URL = `${curPath}/eid/gw/`;
  window.ONEID_PUBLIC_IDP_SITE = `${curPath}/eid/idp/`;
  window.ONEID_PUBLIC_ADMIN_SITE = `${curPath}/eid/`;
  window.ONEID_PUBLIC_PORTAL_SITE = `${curPath}/eid/`;
  window.ONEID_PUBLIC_DOCS_SITE = `${curPath}/eid/docs/`;
  window.ONEID_DINGTALK_IDENTITY_SITE = `${curPath}/eid/idp/`;
  window.ONEID_ACCOUNT_GATEWAY_URL = `${curPath}/eid/gw/`;
  window.ONEID_PUBLIC_OFFICIAL_SITE = officeSite;
};

/**
 * 获取测试环境下的具体测试环境名
 * @returns ci 环境名，rz 环境名，或者空字符串（非ci环境）
 */
export const getCiEnv = () => {
  const { hostname } = window.location;
  return hostname?.match(/(ci-\d{1,}|rz)/)?.[0] || '';
};
/**
 * ci环境变量
 */
const getTestEnv = () => {
  const env = getCiEnv();
  const metEnv = env.replace('ci-', '');
  const getPublicGetWay = () => {
    const paths = location.hostname.split('.');
    const codes = ['account', 'workspace'];
    return codes.find((code) => paths.includes(code));
  };

  window.ONEID_PUBLIC_CDN_URL =
    'https://toa-web-test-1258344699.cos-website.ap-guangzhou.myqcloud.com/public';
  window.ONEID_PUBLIC_IDP_SITE = `https://${env}.account.tencentcs.com`;
  window.ONEID_PUBLIC_ADMIN_SITE = `https://${env}.workspace.tencentcs.com`;
  window.ONEID_PUBLIC_PORTAL_SITE = `https://${env}.workspace.tencentcs.com`;
  window.ONEID_DINGTALK_IDENTITY_SITE = `https://${env}.account.tencentcs.com`;
  window.ONEID_PUBLIC_GATEWAY_URL = `https://api.${env}.${getPublicGetWay()}.tencentcs.com`;
  window.ONEID_ACCOUNT_GATEWAY_URL = `https://api.${env}.account.tencentcs.com`;
  window.ONEID_MEETING_SITE = `https://test-${metEnv}.cicd.tencentmeeting.com`;
  window.ONEID_PUBLIC_DOCS_SITE = `https://pre-account.tencent.com/docs`;
  window.ONEID_PUBLIC_OFFICIAL_SITE = officeSite;
};

/**
 * 预发环境变量
 如果使用容灾域名或者其子域名访问时, 返回对应容灾的域名;
 */
const getPreEnv = () => {
  const hostname = window.location.hostname;
  const isIntlDomain = /(^|\.)tencentid\.com$/.test(hostname);
  const isRZEnv = /(^|\.)rz-(account|workspace)\.tencent\.com$/.test(hostname);
  const envPrefix = isRZEnv ? 'rz-' : 'pre-';

  const accountDomain = isIntlDomain
    ? 'pre-account.tencentid.com'
    : `${envPrefix}account.tencent.com`;
  const workspaceDomain = isIntlDomain
    ? 'pre-workspace.tencentid.com'
    : `${envPrefix}workspace.tencent.com`;

  const currentOfficeSite = isIntlDomain ? officeSiteIntl : officeSite;
  window.ONEID_PUBLIC_CDN_URL = `${currentOfficeSite}/public`;
  window.ONEID_PUBLIC_IDP_SITE = `https://${accountDomain}`;
  window.ONEID_PUBLIC_ADMIN_SITE = `https://${workspaceDomain}`;
  window.ONEID_PUBLIC_PORTAL_SITE = `https://${workspaceDomain}`;

  const gatewaySubdomain = RUNTIME_APP_NAME === 'idp' ? 'account' : 'workspace';
  window.ONEID_PUBLIC_GATEWAY_URL = isIntlDomain
    ? `https://api.pre-${gatewaySubdomain}.tencentid.com`
    : `https://api.${envPrefix}${gatewaySubdomain}.tencent.com`;
  window.ONEID_ACCOUNT_GATEWAY_URL = isIntlDomain
    ? 'https://api.pre-account.tencentid.com'
    : `https://api.${envPrefix}account.tencent.com`;
  window.ONEID_DINGTALK_IDENTITY_SITE = currentOfficeSite.replace('://', '://login.');
  window.ONEID_PUBLIC_OFFICIAL_SITE = currentOfficeSite;
  window.ONEID_MEETING_SITE = 'https://meeting.tencent.com';
};

/**
 * 线上环境变量
 * 如果使用容灾域名或者其子域名访问时, 返回对应容灾的域名;
 */
const getProdEnv = () => {
  const hostname = window.location.hostname;
  const isIntlDomain = /(^|\.)tencentid\.com$/.test(hostname);
  const isRZDomain = /(^|\.)rz-(account|workspace)\.tencent\.com$/.test(hostname);
  const envPrefix = isRZDomain ? 'rz-' : '';

  const accountDomain = isIntlDomain ? 'account.tencentid.com' : `${envPrefix}account.tencent.com`;
  const workspaceDomain = isIntlDomain
    ? 'workspace.tencentid.com'
    : `${envPrefix}workspace.tencent.com`;

  const currentOfficeSite = isIntlDomain ? officeSiteIntl : officeSite;
  window.ONEID_PUBLIC_CDN_URL = `${currentOfficeSite}/public`;
  window.ONEID_PUBLIC_IDP_SITE = `https://${accountDomain}`;
  window.ONEID_PUBLIC_ADMIN_SITE = `https://${workspaceDomain}`;
  window.ONEID_PUBLIC_PORTAL_SITE = `https://${workspaceDomain}`;

  const gatewaySubdomain = RUNTIME_APP_NAME === 'idp' ? 'account' : 'workspace';
  window.ONEID_PUBLIC_GATEWAY_URL = isIntlDomain
    ? `https://api.${gatewaySubdomain}.tencentid.com`
    : `https://api.${envPrefix}${gatewaySubdomain}.tencent.com`;
  window.ONEID_ACCOUNT_GATEWAY_URL = isIntlDomain
    ? 'https://api.account.tencentid.com'
    : `https://api.${envPrefix}account.tencent.com`;
  window.ONEID_DINGTALK_IDENTITY_SITE = currentOfficeSite.replace('://', '://login.');
  window.ONEID_PUBLIC_OFFICIAL_SITE = currentOfficeSite;
  window.ONEID_MEETING_SITE = 'https://meeting.tencent.com';
};

/**
 * 运行时环境变量
 */
export enum RUNTIME_ENV {
  PRIVATE = 'private',
  PROD = 'prod',
  PRE = 'pre',
  TEST = 'test',
  DEV = 'dev',
}

export const getEnv = () => {
  switch (RUNTIME_LOCAL_ENV) {
    case RUNTIME_ENV.PRIVATE:
      getPrivateEnv();
      break;
    case RUNTIME_ENV.PROD:
      getProdEnv();
      break;
    case RUNTIME_ENV.PRE:
      getPreEnv();
      break;
    case RUNTIME_ENV.TEST:
    case RUNTIME_ENV.DEV:
    default:
      getTestEnv();
      break;
  }
};
